export const GROWERS_PATHS = {
  ROOT: '/growers',
  ADD_FIELD: 'add',
  DETAIL: ':userId',
  EDIT: 'edit',
  DRAW: 'draw',
  ENROLLMENTS: 'enrollments',
  DOCUMENTS: 'documents',
  PROGRAM: ':programId',
  UPLOAD: 'upload',
  ENGAGEMENT: ':engagementId',
}

export const GROWERS_ROUTES = {
  ROOT: GROWERS_PATHS.ROOT,
  DETAIL: [GROWERS_PATHS.ROOT, GROWERS_PATHS.DETAIL].join('/'),
  EDIT: [GROWERS_PATHS.ROOT, GROWERS_PATHS.DETAIL, GROWERS_PATHS.EDIT].join('/'),
  ENROLLMENTS: [GROWERS_PATHS.ROOT, GROWERS_PATHS.DETAIL, GROWERS_PATHS.ENROLLMENTS].join('/'),
  PROGRAM: [
    GROWERS_PATHS.ROOT,
    GROWERS_PATHS.DETAIL,
    GROWERS_PATHS.ENROLLMENTS,
    GROWERS_PATHS.PROGRAM,
  ].join('/'),
  DOCUMENTS: [GROWERS_PATHS.ROOT, GROWERS_PATHS.DETAIL, GROWERS_PATHS.DOCUMENTS].join('/'),
  ENGAGEMENT: [
    GROWERS_PATHS.ROOT,
    GROWERS_PATHS.DETAIL,
    GROWERS_PATHS.PROGRAM,
    GROWERS_PATHS.ENGAGEMENT,
  ].join('/'),

  DRAW_GROWER_FIELD: [
    GROWERS_PATHS.ROOT,
    GROWERS_PATHS.DETAIL,
    GROWERS_PATHS.ADD_FIELD,
    GROWERS_PATHS.DRAW,
  ].join('/'),
  UPLOAD_GROWER_FIELD: [
    GROWERS_PATHS.ROOT,
    GROWERS_PATHS.DETAIL,
    GROWERS_PATHS.ADD_FIELD,
    GROWERS_PATHS.UPLOAD,
  ].join('/'),
}

export type GrowersRouteParams = {
  userId?: string
  programId?: string
}
